import { render, staticRenderFns } from "./CertificationAreaChart.vue?vue&type=template&id=2b7aee1a&scoped=true"
import script from "./CertificationAreaChart.vue?vue&type=script&lang=js"
export * from "./CertificationAreaChart.vue?vue&type=script&lang=js"
import style0 from "./CertificationAreaChart.vue?vue&type=style&index=0&id=2b7aee1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7aee1a",
  null
  
)

export default component.exports